import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { MenuStore } from '../../stores/MenuStore';

const IPropTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.element,
  ]).isRequired,
};

const MenuEnforcer = observer((props) => {
  const menusFetched = MenuStore.menus !== null;
  if (!menusFetched) {
    return (
      null
    );
  }
  return props.children;
});

MenuEnforcer.propTypes = IPropTypes;

const enforceMenus = Component => (
  props => (
    <MenuEnforcer>
      <Component {...props} />
    </MenuEnforcer>
  )
);

export { enforceMenus };



// WEBPACK FOOTER //
// ./src/hocs/enforce-menus/EnforceMenus.jsx